<template>
  <div class="sla">
    <div class="sla-content active" @click="clicked()">SLA</div>
    <div class="ball" v-if="sla.aberto_sla > 0 || sla.andamento_sla > 0">{{ sla.aberto_sla + sla.andamento_sla }}</div>
    <transition name="fade">
      <div class="container" v-if="showTab">
        <ul class="tab">
          <li class="column">
            <div class="mb text-center">
              <b>Novos Jobs</b>
            </div>
            <br />
            <div class="row justify-around">
              <router-link to="/funcionario/jobs/novos" class="grid-6 row align-center pointer">
                <div class="span">{{ sla.aberto }}</div>
                Novos
              </router-link>
              <router-link to="/funcionario/jobs/aberto" class="grid-6 row align-center pointer">
                <div class="span out">{{ sla.aberto_sla }}</div>
                SLA Vencido
              </router-link>
            </div>
          </li>

          <li class="column">
            <div class="mb text-center">
              <b>Meus Jobs</b>
            </div>
            <br />
            <div class="row justify-around">
              <router-link to="/funcionario/jobs/andamento" class="grid-6 row align-center pointer">
                <div class="span">{{ sla.andamento }}</div>
                Em andamento
              </router-link>
              <router-link to="/funcionario/jobs/sla" class="grid-6 row align-center pointer">
                <div class="span out">{{ sla.andamento_sla }}</div>
                SLA Vencido
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </transition>
    <div class="mask" @click="clicked()" v-if="showTab"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "SLA",
  data() {
    return {
      showTab: false,
      sla: {}
    };
  },
  beforeMount() {
    this.getSLA();
  },
  methods: {
    ...mapActions("admin", ["SLA"]),
    clicked() {
      this.showTab = !this.showTab;
    },
    getSLA() {
      this.SLA().then(r => {
        if (r.data) this.sla = r.data;
      });
      var self = this;
      setTimeout(function () {
        self.getSLA();
      }, 60000);
    }
  },
  computed: {
    ...mapGetters("general", ["notify"])
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.sla {
  margin-right: 25px;

  &-content {
    text-align: center;
    background: $red-3;
    color: $white;
    border-radius: 50%;
    font-size: 14px;
    font-weight: bold;
    line-height: 30px;
    width: 32px;
    height: 32px;
    padding: 2px;
    border: 2px solid $red-3;
    cursor: pointer;

    &:hover {
      border: 2px solid $white;
    }
  }

  .clear {
    font-size: 0.8rem;
    text-align: center;
    padding: 0.8rem 0rem;
    color: $gray-4;
    letter-spacing: 0.1rem;
    font-weight: bold;

    &:hover {
      cursor: pointer;
      background: $green-1;
      color: $white;
    }
  }

  .mask {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 900;
  }

  .ball {
    background: white;
    color: $red-3;
    font-weight: bold;
    position: absolute;
    border-radius: 100%;
    padding: 3px;
    font-size: 13px;
    margin-top: -45px;
    margin-left: 24px;
  }

  .mb {
    margin-bottom: 5px;
    color: $purple;
    font-size: 20px;
  }

  .container {
    border-radius: 22px;

    @media (max-width: $small) {
      right: 0px;
      left: 0px;
    }

    @media (min-width: $small) {
      margin-left: -155px;

    }

    position: absolute;
    @include border;
    z-index: 999;
    background: $white;
    margin-top: 12px;

    @media (min-width: $small) {
      &:before {
        top: -8px;
        content: " ";
        position: absolute;
        display: block;
        border: 10px solid #fff;
        transform: rotate(45deg);
        left: 162px;
      }
    }

    .tab {
      width: 350px;
      max-height: 260px;
      overflow: auto;

      @media (max-width: $small) {
        width: 100%;
      }

      li {
        padding: 15px 10px;
        text-align: left;
        color: $gray-4;
        border-bottom: 1px solid $white-3;
        font-size: 16px;
        line-height: 30px;

        .pointer {
          padding: 8px;
          border-radius: 8px;

          &:hover {
            background: $purple;
            color: white
          }
        }

        .span {
          width: 30px;
          height: 30px;
          text-align: center;
          background: $green-1;
          color: $white;
          border-radius: 50%;
          font-weight: bold;
          margin-right: 6px;

          &.out {
            background: $red-3;
          }

        }
      }
    }
  }
}
</style>